import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to manage your impact.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title" style={{paddingTop:'0px !important'}}>
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">isn't it interesting?</span>
                                            </div>
                                            <p>Two billion years ago a meteorite 10km in diameter hit the earth
                                                southwest of Johannesburg, South Africa, creating an enormous
                                                crater – the Vredefort Dome. The impact would have vaporised
                                                about 70km<a className="superscripttext"
                                                             href="further_info.php?course=300"><sup>3</sup></a> of
                                                rock and may have increased the earth’s oxygen levels to a
                                                degree that made the development of multicellular life possible…
                                            </p>


                                            <div className="border_subtitle">It’s all about style</div>
                                            <div className="paraspace"><p>Now that’s an impact. So how can you
                                                make an impact?</p></div>
                                            <p>Our style: the way we act, dress, behave and talk all have a
                                                significant influence on how we are perceived and evaluated by
                                                others. The trick is to be able to adjust your approach to suit
                                                the situation. The style you use to present information is what
                                                often determines the impact you make, described below.</p>


                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <div className="border_subtitle">Minority influence</div>
                                                <p>In the late 1960s, Moscovici conducted a series of
                                                    experiments<a className="superscripttext"
                                                                  href="further_info.php?course=300"><sup>1</sup></a> looking
                                                    into the way in which certain individuals had the power to
                                                    influence the thinking and beliefs of future generations.
                                                    His studies into innovation and creativity and the power of
                                                    the few to influence others led him to pinpoint a certain
                                                    behavioural style that an individual or minority must adapt
                                                    in order to be able to influence a majority view. </p>
                                                <p>In a simple experiment, Moscovici showed some participants
                                                    with normal vision a coloured slide and asked them to
                                                    indicate its colour and brightness. The participants were
                                                    asked to do this 36 times in a sequence, each time being
                                                    shown the same blue slide. Moscovici set up three different
                                                    conditions, each with 6 participants:</p>

                                                <ol className="brownbullet-list listcontentSpacing">

                                                    <li style={{paddingBottom:'0px !important'}}><p>There were 4
                                                        real participants and 2 paid confederates who were
                                                        instructed to call the slides green instead of blue on
                                                        all trials.</p></li>

                                                </ol>
                                            </div>


                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page2')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }